/*
 * Public API Surface of filestore-lib
 */

import '@angular/localize/init';
export * from './lib/filestore.module';
export * from './lib/filestore-browser/filestore-browser.component';
export * from './lib/filestore-upload-web/filestore-upload-web.component';
export * from './lib/filestore.service'